// import XLSX from 'xlsx';
const XLSX = require("xlsx");
// xmlbuilder lib/Utility.js 中 assign的参数
// ...sources ie 报错 做以下修改
// ```js
//       var target
//       for (i = 0, len = sources.length; i < 1; i++) {
//         target = sources[i];
//       }
//       for (i = 1, len = sources.length; i < len; i++) {
//       // for (i = 0, len = sources.length; i < len; i++) {
// import builder from 'xmlbuilder';
// import fs from 'fs';
// import FileSaver from 'file-saver';
// import iconv from 'iconv-lite';

import _ from "lodash";
import moment from "moment";

// import { getColumnsTitle, getBcBookColumn } from './bookColumn';

// const xml2js = require('xml2js');

// const STORAGE_CURRENT_USER_NAME = 'CURRENT USER';
// interface ColInfo {
//     /* visibility */
//     hidden?: boolean; // if true, the column is hidden

//     /* column width is specified in one of the following ways: */
//     wpx?: number; // width in screen pixels
//     width?: number; // width in Excel's "Max Digit Width", width*256 is integral
//     wch?: number; // width in characters

//     /* other fields for preserving features from files */
//     MDW?: number; // Excel's "Max Digit Width" unit, always integral
// }

// 原来用列名当下标 但是遇上同样列名的就麻烦了
// 应该用dataIndex当下标，第一行弄个列名行就行了
async function create_sheet(data, cols, skipHeader = true) {
  let wscols;
  let rows;
  const cellWidths = [];
  if (cols) {
    // const keys = _.map(cols, 'dataIndex');
    // wscols = cols.map(col => ({ wch: col.width || 20 }))
    wscols = _.map((row) => _.pick(row, ["hidden", "wpx", "width", "wch", "MDW"]));
    // data = data.map(row => _.pick(row, keys))
    rows = data.map((row) => {
      const newrow = {};
      cols.forEach((col) => {
        if ("cellwidth" in col) {
          cellWidths.push({ wpx: col.cellwidth });
        } else {
          cellWidths.push({ wpx: 100 });
        }
        if ("dataType" in col && col.dataType === "date" && row[col.dataIndex] != null && row[col.dataIndex] !== "") {
          newrow[col.title || col.dataIndex || ""] = moment(row[col.dataIndex]).format("YYYY-MM-DD");
        } else if (
          "dataType" in col &&
          col.dataType === "yearmonth" &&
          row[col.dataIndex] != null &&
          row[col.dataIndex] !== ""
        ) {
          newrow[col.title || col.dataIndex || ""] = moment(row[col.dataIndex]).format("YYYY-MM");
        } else {
          newrow[col.title || col.dataIndex || ""] = col.render
            ? col.render(row[col.dataIndex], row)
            : row[col.dataIndex];
        }
      });
      return newrow;
    });
    // console.log('cols: ', cols, header, wscols, rows);
  }
  // 原来用列名当下标 但是遇上同样列名的就麻烦了
  // 应该用dataIndex当下标，第一行弄个列名行就行了
  const opts = {};
  if (skipHeader) {
    opts.skipHeader = skipHeader;
    opts.header = _.map(cols, "dataIndex");
    rows = [
      _.mapValues(_.keyBy(cols, "dataIndex"), (o) => {
        return o.title;
      }),
      // 只拿header里有的
      ..._.map(data, _.partialRight(_.pick, opts.header)),
    ];
  } else {
    opts.header = _.map(cols, "title");
  }
  const ws = await XLSX.utils.json_to_sheet(rows, opts);
  // if (wscols) ws['!cols'] = wscols;
  // console.log(ws)
  ws["!cols"] = cellWidths;
  return ws;
}

export async function outExcel(data, cols, filename, wsname, filetype = "xlsx") {
  console.log("Excel.outExcel: ", data, cols, filename, wsname);
  if (!filename) {
    filename = "temp";
  }
  filename = `${filename}_${moment().format("YYYYMMDD_HHmm")}`;
  if (!wsname) {
    wsname = "Sheet1";
  }
  /* create a new blank workbook */
  const wb = XLSX.utils.book_new();
  const ws = await create_sheet(data, cols);
  /* Add the worksheet to the workbook */
  XLSX.utils.book_append_sheet(wb, ws, wsname);
  /* output format determined by filename */
  await XLSX.writeFile(wb, `${filename}.${filetype}`);
  /* at this point, out.xlsb will have been downloaded */
  return { code: 0, message: "Excel File Created!" };
}

export async function outSheets(data, cols, filename) {
  console.debug("Excel.outSheets: ", data, cols, filename);
  if (!filename) filename = `temp_${moment().format("YYYYMMDD_HHmm")}`;
  const XLSX = require("xlsx");
  console.debug("XLSX: ", XLSX);
  const wb = await XLSX.utils.book_new();
  // Promise.all(data.forEach(async sheet => {
  // await data.map(async sheet => {
  //   // if (sheet.list.length === 0) return
  //   console.debug('sheet: ', sheet);
  //   /* if (!wsname) wsname = filename; */
  //   const wsname = `${sheet.title}(${sheet.id})`;
  //   /* create a new blank workbook */
  //   const ws = await this.create_sheet(sheet.list, cols);
  //   console.debug('ws.', ws)
  //   /* Add the worksheet to the workbook */
  //   XLSX.utils.book_append_sheet(wb, ws, wsname);
  //   console.debug('loop.', wb)
  //   return ws
  // })
  const wss = data.map(async (sheet) => {
    if (!sheet.list || sheet.list.length === 0) return sheet;
    console.debug("sheet: ", sheet);
    /* create a new blank workbook */
    const ws = await create_sheet(sheet.list, cols);
    return { ...sheet, __ws: ws };
  });
  console.debug("wss is over.", wss);
  Promise.all(wss).then(async (res) => {
    console.debug("res: ", res);
    res.forEach((sheet) => {
      if (!sheet.list || sheet.list.length === 0) return;
      if (!sheet.id) return;
      /* if (!wsname) wsname = filename; */
      // const wsname = `${sheet.title}(${sheet.id})`;
      const wsname = `${sheet.title}`;
      if (wb.SheetNames.indexOf(wsname) >= 0) console.error("出现重复数据？", sheet);
      // eslint-disable-next-line no-underscore-dangle
      XLSX.utils.book_append_sheet(wb, sheet.__ws, wsname);
    });
    // console.debug('sheets is over.', wb)
    /* output format determined by filename */
    console.debug("will write: ", wb);
    if (wb.SheetNames.length <= 0) return { code: -1, message: "Workbook is empty!" };
    await XLSX.writeFile(wb, `${filename}.xlsx`);
    /* at this point, out.xlsb will have been downloaded */
    return { code: 0, message: "Excel File Created!" };
  });
}

/**
 * 导出
 */
// export default {
//   Excel: 'excel',
//   Xml: 'xml',
//   // columns_book: {},

//   async out(format = this.Excel, data, cols, filename, wsname, filetype = 'xlsx') {
//     console.log('Excel.out: ', format, data, cols, filename, wsname, filetype);
//     if (format === this.Excel) return this.outExcel(data, cols, filename, wsname);
//     if (format === this.Xml) return this.outXml(data, filename);
//     return { code: -1, message: 'Wrong Format.' };
//   },

//   // async outXml(data, filename) {
//   //   let xml = '';
//   //   // const xml = builder
//   //   //   .create({ CIPData: data }, { encoding: 'gb2312', keepNullNodes: true, openNode: true })
//   //   //   .end({ pretty: true });
//   //   const builder = new xml2js.Builder({ xmldec: { encoding: 'gb2312' } });
//   //   // builder.xmldec({ encoding: 'gb2312' })
//   //   xml = builder.buildObject({ CIPData: data });
//   //   console.log(xml);
//   //   // Note: Ie and Edge don't support the new File constructor,
//   //   // so it's better to construct blobs and use saveAs(blob, filename)
//   //   // const file = new File(xml, `${filename}.xml`, { type: 'text/plain;charset=utf-8' });
//   //   // // FileSaver.saveAs(file);
//   //   // saveAs(file);
//   //   const blob = new Blob([iconv.encode(xml, 'gb2312')], { type: 'text/plain;charset=gb2312' });
//   //   // const blob = new Blob([xml], { type: 'text/plain;charset=gb2312' });
//   //   await FileSaver.saveAs(blob, `${filename}.xml`);
//   //   // fs.writeFileSync(`${filename}.xml`, 'xml');
//   //   // await XLSX.writeFile(xml, `${filename}.xml`);
//   //   return { code: 0, message: 'Xml File Created!' };
//   // },

//   // getColumns() {
//   //   const columns = getColumnsTitle();
//   //   console.log('columns: ', columns);
//   //   const arr = [];
//   //   _.forEach(columns, (value, key) => {
//   //     const { colName, render } = value;
//   //     const newcol = { dataIndex: colName.toLowerCase(), title: key, checked: true, render };
//   //     if ('isTime' in value) {
//   //       newcol.dataType = 'date';
//   //     }
//   //     if (
//   //       'publishPlanTime'.toLowerCase() === colName.toLowerCase() ||
//   //       'publishRealTime'.toLowerCase() === colName.toLowerCase()
//   //     ) {
//   //       newcol.dataType = 'yearmonth';
//   //     }
//   //     arr.push(newcol);
//   //   });

//   //   const columnsBc = getBcBookColumn();
//   //   _.forEach(columnsBc, (value, key) => {
//   //     const { colName, render } = value;
//   //     const newcol = { dataIndex: colName.toLowerCase(), title: key, checked: true, render };
//   //     if ('isTime' in value) {
//   //       newcol.dataType = 'date';
//   //     }
//   //     arr.push(newcol);
//   //   });

//   //   return arr;
//   // },
// };



// WEBPACK FOOTER //
// ./src/utils/Export.js